export const engagementGetTableDefinitions = "/engagement/expressive_report/table_definitions";
